import { render, staticRenderFns } from "./movie-add.vue?vue&type=template&id=9f5f9b46&scoped=true"
import script from "./movie-add.vue?vue&type=script&lang=js"
export * from "./movie-add.vue?vue&type=script&lang=js"
import style0 from "./movie-add.vue?vue&type=style&index=0&id=9f5f9b46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5f9b46",
  null
  
)

export default component.exports